import { RoutingTabTitleService } from '@shared/service';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { filter, map, tap } from 'rxjs/operators';

import { SeoComponent } from '@shared/components';
import { ExchangeRateService, SnapshotsService } from '../services';
import { WindowService } from '@shared/window';
import { MetrixConfiguratorComponent } from '../components/metrix-configurator/metrix-configurator.component';
import { ExampleProductsComponent } from '../components/example-products/example-products.component';
import { SimilarStyleComponent } from '../components/similar-style/similar-style.component';
import { AwardedCollectionsComponent } from '../../shared/components/awarded-collections/awarded-collections.component';
import { OurShowroomComponent } from '../../shared/components/our-showroom/our-showroom.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../i18n/pipes/lozalize.pipe';

@Component({
    selector: 'app-configurator',
    templateUrl: './configurator.component.html',
    styleUrls: ['./configurator.component.scss'],
    providers: [SnapshotsService, ExchangeRateService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink,
        MetrixConfiguratorComponent,
        ExampleProductsComponent,
        SimilarStyleComponent,
        AwardedCollectionsComponent,
        OurShowroomComponent,
        AsyncPipe,
        TranslatePipe,
        LocalizePipe,
    ],
})
export class ConfiguratorComponent extends SeoComponent implements OnInit, OnDestroy {
    private snapshotsService = inject(SnapshotsService);
    private routingTabTitleService = inject(RoutingTabTitleService);
    private activatedRoute = inject(ActivatedRoute);
    private exchangeRateService = inject(ExchangeRateService);
    private windowService = inject(WindowService);

    euro$ = this.exchangeRateService.euro$;

    snapshots$ = this.snapshotsService.snapshots$;
    snapshotId$ = this.activatedRoute.params.pipe(
        filter((params: { snapshot: string }) => !!params.snapshot),
        map((params) => params.snapshot),
    );

    override ngOnInit(): void {
        this.windowService.scrollTop();

        super.ngOnInit();

        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap((title) => {
                        this.seoTitle$.next(title);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.CONFIGURATOR.description'));
                    }),
                )
                .subscribe(),
        );

        this.exchangeRateService.dispatch();
        this.snapshotsService.dispatch();
    }
}
